import React from 'react';
import { Layout } from '../components/Layout';
import { motion } from 'framer-motion';
interface CategoryPageProps {
  title: string;
  description: string;
  image: string;
}
export function CategoryPage({
  title,
  description,
  image
}: CategoryPageProps) {
  // Placeholder products for the category
  const products = Array.from({
    length: 8
  }).map((_, i) => ({
    id: i,
    name: `Produit ${title} ${i + 1}`,
    price: (Math.random() * 100 + 10).toFixed(2),
    image: `${image}?auto=format&fit=crop&q=80&w=400&sig=${i}` // Add sig to avoid duplicate images
  }));
  return <Layout data-id="element-155">
      {/* Category Hero */}
      <div className="relative h-[40vh] min-h-[300px] flex items-center justify-center overflow-hidden" data-id="element-156">
        <div className="absolute inset-0" data-id="element-157">
          <img src={image} alt={title} className="w-full h-full object-cover" data-id="element-158" />
          <div className="absolute inset-0 bg-brand-navy/60" data-id="element-159" />
        </div>
        <div className="relative z-10 text-center px-4" data-id="element-160">
          <motion.h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4" initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} data-id="element-161">
            {title}
          </motion.h1>
          <motion.p className="text-lg text-white/90 max-w-2xl mx-auto" initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.1
        }} data-id="element-162">
            {description}
          </motion.p>
        </div>
      </div>

      {/* Product Grid */}
      <div className="container mx-auto px-4 md:px-6 lg:px-8 py-16" data-id="element-163">
        <div className="flex justify-between items-center mb-8" data-id="element-164">
          <h2 className="text-2xl font-heading font-bold text-brand-navy" data-id="element-165">
            Tous les produits
          </h2>
          <select className="border border-gray-300 rounded-md py-2 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-brand-green" data-id="element-166">
            <option data-id="element-167">Trier par pertinence</option>
            <option data-id="element-168">Prix croissant</option>
            <option data-id="element-169">Prix décroissant</option>
          </select>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-id="element-170">
          {products.map((product, index) => <motion.div key={product.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.05
        }} className="bg-white border border-gray-100 rounded-xl overflow-hidden hover:shadow-lg transition-shadow group" data-id="element-171">
              <div className="relative h-48 overflow-hidden bg-gray-100" data-id="element-172">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-173" />
              </div>
              <div className="p-4" data-id="element-174">
                <h3 className="font-semibold text-gray-800 mb-1" data-id="element-175">
                  {product.name}
                </h3>
                <p className="text-brand-green font-bold text-lg" data-id="element-176">
                  {product.price} €
                </p>
                <button className="mt-4 w-full bg-gray-50 hover:bg-brand-green hover:text-white text-brand-navy font-medium py-2 rounded-md transition-colors" data-id="element-177">
                  Ajouter au panier
                </button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </Layout>;
}